import { AdminTransfer } from '../models'
import type { ColumnsType } from 'antd/lib/table'
import {
  getTransferUser,
  getTransformedDateTime,
  getTransferCompanyName,
  getTransferOrderedyByDate,
} from '../helpers'
import {
  CustomTitle,
  CustomHeaderText,
  TransferTotalColumn,
  TransferListActionsColumn,
  TransferListColumnMovileView,
} from 'src/components'

const transfersColumns: ColumnsType<AdminTransfer> = [
  /* Purchase Documents Data */

  {
    title: () => <CustomHeaderText text='Deposits.Reference' />,
    responsive: ['sm'],
    sorter: (a: AdminTransfer, b: AdminTransfer) => a.order.reference.length - b.order.reference.length,
    render: (_, transfer) => <CustomTitle label={transfer.order.reference} />
  },
  {
    title: () => <CustomHeaderText text='Withdrawals.CreatedDate' />,
    responsive: ['sm'],
    sorter: (a: AdminTransfer, b: AdminTransfer) => getTransferOrderedyByDate(a, b),
    render: (_, transfer) => <CustomTitle label={getTransformedDateTime(transfer.order.created)} type={null} />
  },
  {
    title: () => <CustomHeaderText text='Deposits.Total' />,
    responsive: ['sm'],
    sorter: (a: AdminTransfer, b: AdminTransfer) => a.order.total - b.order.total,
    render: (_, transfer) => <TransferTotalColumn transfer={transfer} />
  },
  {
    title: () => <CustomHeaderText text='developers.User' />,
    responsive: ['sm'],
    sorter: (a: AdminTransfer, b: AdminTransfer) => getTransferUser(a)?.length - getTransferUser(b)?.length,
    render: (_, transfer) => <CustomTitle label={getTransferUser(transfer)} type={null} />
  },
  {
    title: () => <CustomHeaderText text='menuItems.Company' />,
    responsive: ['sm'],
    sorter: (a: AdminTransfer, b: AdminTransfer) => {
      return getTransferCompanyName(a)?.length - getTransferCompanyName(b)?.length
    },
    render: (_, transfer) => <CustomTitle label={getTransferCompanyName(transfer)} type={null} />
  },

  /* Actions  */
  {
    title: () => <CustomHeaderText text='general.Actions' />,
    responsive: ['sm'],
    render: (_, transfer) => <TransferListActionsColumn transfer={transfer} />
  },

  /* Mobile View */
  {
    title: () => <CustomHeaderText text='Projects.Transfer.Title' isCentered />,
    responsive: ['xs'],
    sorter: (a: AdminTransfer, b: AdminTransfer) => getTransferOrderedyByDate(a, b),
    render: (_, transfer) => <TransferListColumnMovileView transfer={transfer} />
  },
]

export default transfersColumns
